import { useEffect, useRef, useState } from 'react';
import { PostCardSkeleton } from './PostCardSkeleton';

type Props = {
  onLoadMore: () => void;
  isLoadingMore: boolean;
};

export const FeedLoadMore = ({ onLoadMore, isLoadingMore }: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    });
    if (sentinelRef.current) observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !isLoadingMore) onLoadMore();
  }, [isVisible, isLoadingMore, onLoadMore]);

  return (
    <div ref={sentinelRef} data-testid="feed-load-more">
      <PostCardSkeleton />
    </div>
  );
};
